<template>
  <v-layout fill-height column class="page-solution-note">
    <div class="question" v-html="ques[0]"></div>
    <div class="answer">
      <Textarea
          :value="textarea"
          :height="200"
          :counter="500"
          :placeholder=replyArr[0]
          :isBtns="isBtns"
          :isRecording="isRecording"
          :beForePhotoNo="beForePhotoNo"
          @loading="loading"
          @photo="photo"
          @recording="recording"
          @input="textareaVaule"
          :readonly="this.cmplt"
          ref="child_component"
      />
      <div class="d-flex align-center" v-if="isPhoto || isVoiceNote">
        <Photo v-if="isPhoto"
               :src="$downUrl(photoFileName)" :isLoading="isLoading" @photoDelete="photoDelete"
               :showCloseBtn="isPhoto&&!cmplt"
               class="mr-2"
        />
<!--        <Photo v-else-if="isPhoto&&cmplt" :src="$downUrl(photoFileName)" class="mr-2"-->
<!--               :showCloseBtn="isPhoto&&!cmplt"-->
<!--        />-->
        <!-- <Photo :src="getImage(photoNo)" class="mr-2" /> -->
        <VoiceNote v-if="isVoiceNote" class="flex-1"
                   :miniSize="isPhoto ? true:false" :isClose="isVoiceNote&&!cmplt"
                   :voiceNote="voiceNote" :voice-file-name="voiceFileName" @voiceDelete="voiceDelete" ref="voiceNote"
        />
      </div>
    </div>
    <!-- <FooterBtnsNext  @before="$emit('before')" @next="$emit('next')" :current="current" :total="total" :disabledNext="disabledNext"/> -->
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabled"/>
    <RecordingSheet :sheet="sheet" :beForeVoiceNote="beForeVoiceNote" @sheetClose="sheetStatus"
                    @recordingSave="recordingSave"/>
  </v-layout>
</template>
<script>
import store from '@/store'
import utils from '@/utils/utils'
import Textarea from "@/components/forms/Textarea"
import VoiceNote from "@/components/solution/VoiceNote"
import Photo from "@/components/solution/Photo"
import RecordingSheet from "@/components/layout/bottomSheet/RecordingSheet"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  components: {
    Textarea,
    Photo,
    VoiceNote,
    RecordingSheet,
    FooterBtnsNext
  },
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq", "regDt"],
  data: () => ({
    sheet: false,
    isBtns: true,
    isRecording: true,
    voiceNote: '',
    beForeVoiceNote: 0,
    // photoNo: 'photo.png',
    photoNo: '',
    beForePhotoNo: 0,

    photoFileName: null,
    voiceFileName: null,

    textarea: '',
    disabledNext: true,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyObjArr: [],
    userReplyNo: [0, 0, 0],
    userReply: [],
    beforeList: [],
    enableList: [],
    isLoading: false,
    clientCd: '',
  }),
  computed: {
    disabled() {
      if (this.disabledNext || this.isLoading) {
        return true
      }
      return false
    },
    isPhoto() {
      if (this.photoNo < 0) {
        return true
      } else if (this.photoNo > 0 && this.photoNo !== null && this.photoNo !== '' && this.photoNo !== undefined) {
        return true
      } else {
        return false
      }
      // return (this.photoNo > 0 && this.photoNo !== null && this.photoNo !== '' && this.photoNo !== undefined) ? true : false;
    },
    isVoiceNote() {
      return (this.voiceNote > 0 && this.voiceNote !== null && this.voiceNote !== '' && this.voiceNote !== undefined) ? true : false;
    },
    isLive() {
      // TODO. 임시코드 삭제예정 삼성화재 개발/검증계 테스트용도
      let loc = window.location.host
      if (loc.includes('localhost')) return false;
      else if (loc.includes('happymint.dev')) return false;
      else if (loc.includes('happymint.kr')) return true;

      return true;
    }
  },
  watch: {
    beForePhotoNo() {
      // console.log("watch this.beForePhotoNo : ", this.beForePhotoNo)
      // this.$refs.child_component.beForePhotoNo = this.beForePhotoNo
    }
  },
  created() {
    this.clientCd = this.$store.state.auth.authUser.clientCd
  },
  mounted() {


    if (this.clientCd === 'samsungfire' && this.isLive) {
      this.isBtns = false
      this.isRecording = false
    }
    if (this.$route.query.cmpltYn) {
      this.isBtns = false
    }

    this.getUnitDetailUse()
  },
  beforeDestroy() {
    if (this.voiceNote > 0 && this.voiceNote !== null && this.voiceNote !== '' && this.voiceNote !== undefined) {
      this.$refs.voiceNote.audioPause();
    }
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true
      // this.beForePhotoNo.splice(0, this.beForePhotoNo.length)

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [
              {'unitUseNo': this.unitUseNo},
              {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
              {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
              {'freeYn': 'Y'},
              {'regDt': this.regDt},
              {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
              this.ques.push(quesEl.ques)
              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                if (this.clientCd === 'samsungfire' && this.isLive) {
                  this.replyArr.push("떠오르는 것들을 기록해보세요")
                } else {
                  this.replyArr.push(replyEl.reply)
                }
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo

                if (userReplyEl.reply == '사진') {
                  if (userReplyEl.score != null) {
                    this.photoNo = userReplyEl.score
                    this.beForePhotoNo = userReplyEl.score
                    this.photoFileName = userReplyEl.fileName
                  }
                } else if (userReplyEl.reply == '녹음') {
                  if (userReplyEl.score != null && userReplyEl.score > 0) {
                    this.isRecording = false
                    this.voiceNote = userReplyEl.score
                    this.beForeVoiceNote = userReplyEl.score
                    this.voiceFileName = userReplyEl.fileName
                  }
                } else {
                  this.textarea = userReplyEl.reply
                  this.textareaVaule(this.textarea)
                }

              });
            });

          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        var i = 0

        // 서술형 답변
        this.userReply[i] = {
          unitId: this.replyObjArr[0].unitId,
          sltUnitMappingUseNo: this.replyObjArr[0].sltUnitMappingUseNo,

          memberUnitDtlReplyUseNo: this.userReplyNo[0],
          // unitUseNo: this.replyObjArr[0].unitUseNo,
          unitNo: this.replyObjArr[0].unitNo,
          // unitDtlUseNo: this.replyObjArr[0].unitDtlUseNo,
          unitDtlNo: this.replyObjArr[0].unitDtlNo,
          // unitDtlQuesUseNo: this.replyObjArr[0].unitDtlQuesUseNo,
          unitDtlQuesNo: this.replyObjArr[0].unitDtlQuesNo,
          // unitDtlReplyUseNo: this.replyObjArr[0].unitDtlReplyUseNo,
          unitDtlReplyNo: this.replyObjArr[0].unitDtlReplyNo,
          userKey: this.$store.state.auth.authUser.userKey,
          reply: this.textarea,
          // score: score/10,
          freeYn: this.free
        }
        i++

        // 사진 답변
        var inputPhotoNo = 0
        if (this.photoNo != '') {
          inputPhotoNo = this.photoNo

          this.enableList.push(this.photoNo)
        }
        this.userReply[i] = {
          unitId: this.replyObjArr[1].unitId,
          sltUnitMappingUseNo: this.replyObjArr[1].sltUnitMappingUseNo,

          memberUnitDtlReplyUseNo: this.userReplyNo[1],
          // unitUseNo: this.replyObjArr[1].unitUseNo,
          unitNo: this.replyObjArr[1].unitNo,
          // unitDtlUseNo: this.replyObjArr[1].unitDtlUseNo,
          unitDtlNo: this.replyObjArr[1].unitDtlNo,
          // unitDtlQuesUseNo: this.replyObjArr[1].unitDtlQuesUseNo,
          unitDtlQuesNo: this.replyObjArr[1].unitDtlQuesNo,
          // unitDtlReplyUseNo: this.replyObjArr[1].unitDtlReplyUseNo,
          unitDtlReplyNo: this.replyObjArr[1].unitDtlReplyNo,
          userKey: this.$store.state.auth.authUser.userKey,
          reply: "사진",
          score: inputPhotoNo,
          // score: this.photoNo,
          freeYn: this.free
        }
        i++ // 사진 등록될때만 증가

        // 녹음 답변
        var inputVoiceNote = 0
        if (this.voiceNote != '') {
          inputVoiceNote = this.voiceNote

          this.enableList.push(this.voiceNote)
        }
        this.userReply[i] = {
          unitId: this.replyObjArr[2].unitId,
          sltUnitMappingUseNo: this.replyObjArr[2].sltUnitMappingUseNo,

          memberUnitDtlReplyUseNo: this.userReplyNo[2],
          // unitUseNo: this.replyObjArr[2].unitUseNo,
          unitNo: this.replyObjArr[2].unitNo,
          // unitDtlUseNo: this.replyObjArr[2].unitDtlUseNo,
          unitDtlNo: this.replyObjArr[2].unitDtlNo,
          // unitDtlQuesUseNo: this.replyObjArr[2].unitDtlQuesUseNo,
          unitDtlQuesNo: this.replyObjArr[2].unitDtlQuesNo,
          // unitDtlReplyUseNo: this.replyObjArr[2].unitDtlReplyUseNo,
          unitDtlReplyNo: this.replyObjArr[2].unitDtlReplyNo,
          userKey: this.$store.state.auth.authUser.userKey,
          reply: "녹음",
          score: inputVoiceNote,
          freeYn: this.free
        }
        i++
        this.disabledNext = true
        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {

              // 삭제 대상이 있으면 삭제
              if (this.beforeList.length > 0) {
                utils.File.fileDelete(this.beforeList
                ).then(() => {
                  // console.log("삭제 : ", response.data)
                })
                  .catch(async error => {
                    console.log(error)
                  })
                  .finally(() => {
                  })
              }

              if (this.enableList.length > 0) {
                utils.File.fileEnable(this.enableList
                ).then(() => {
                  this.disabledNext = false
                  this.$emit('next')
                })
                  .catch(async error => {
                    console.log(error)
                  })
                  .finally(() => {
                  })
              } else {
                setTimeout(() => {
                  this.disabledNext = false
                  this.$emit('next')
                }, 500); // 저장한 이후
              }
            } else {
              console.log(res.msg)
            }
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    photoDelete() {
      this.beforeList.push(this.photoNo)
      this.photoNo = ''
      this.beForePhotoNo = 0
    },
    voiceDelete() {
      this.beforeList.push(this.voiceNote)
      this.voiceNote = ''
      this.isRecording = true
    },
    sheetStatus() {
      this.sheet = !this.sheet;
    },
    loading(val) {
      this.isLoading = val
    },
    photo(fileId, beforeFileId, fileName) {

      if (fileId == 'error') {
        console.log('사진 업로드 실패하였습니다.')
        this.photoNo = ''
        // this.beForePhotoNo = 0
      } else {
        this.beforeList.push(this.beForePhotoNo)
        this.photoNo = fileId
        this.beForePhotoNo = beforeFileId
        this.photoFileName = fileName
        this.beForePhotoFileName = fileName
      }
    },
    recording() {
      this.sheet = true;
    },
    recordingSave(fileId, beforeFileId, fileName) {

      if (fileId == 'error') {
        console.log('녹음파일 업로드 실패하였습니다.')
      } else {
        // this.beforeList.push(this.beForeVoiceNote)
        this.voiceNote = fileId
        this.beForeVoiceNote = beforeFileId
        this.voiceFileName = fileName
        this.sheet = false
        this.isRecording = false
      }
    },
    textareaVaule(value) {
      this.textarea = value;
      if (this.textarea == "" || this.textarea.length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    }
  }
}
</script>
